import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
// import classes from "../technicalOverviewComponents/techOverview.module.scss";
import classes from "./ObjectPlaygroundComponents.module.scss";
import arrowIcon from "../../assets/arrow.svg";

const Response = ({ response, request }) => {
  const [isResponseOpen, setIsResponseOpen] = useState(true);
  // const [isRequestOpen, setIsRequestOpen] = useState(false);
  const [isDocOpen, setIsDocOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => {
          setIsResponseOpen((prev) => !prev);
          setIsDocOpen(false);
        }}
        aria-controls="intro-collapse-text"
        aria-expanded={isResponseOpen}
        className={`${classes.btn} d-flex align-items-center justify-content-between pb-2 px-0 w-100`}
      >
        Response <img src={arrowIcon} alt="" style={{ width: "12px" }} />
      </button>
      <Collapse in={isResponseOpen}>
        <pre className={classes["pre-fields"]}>
          {JSON.stringify(response, null, 2)}
        </pre>
      </Collapse>

      {/* <button
        onClick={() => setIsRequestOpen((prev) => !prev)}
        aria-controls="intro-collapse-request"
        aria-expanded={isRequestOpen}
        className={`${classes.btn} d-flex align-items-center justify-content-between pb-2 px-0 w-100`}
      >
        Request <img src={arrowIcon} alt="" style={{ width: "12px" }} />
      </button>
      <Collapse in={isRequestOpen}>
        <pre className={otherClasses["pre-fields"]}>
          {JSON.stringify(request, null, 2)}
        </pre>
      </Collapse> */}

      {response.result && response.result.ReturnDoc && (
        <>
          <button
            onClick={() => {
              setIsDocOpen((prev) => !prev);
              setIsResponseOpen(false);
            }}
            aria-controls="intro-collapse-doc"
            aria-expanded={isDocOpen}
            className={`${classes.btn} d-flex align-items-center justify-content-between pb-2 px-0 w-100`}
          >
            Document <img src={arrowIcon} alt="" style={{ width: "12px" }} />
          </button>
          <Collapse in={isDocOpen}>
            <div className={classes["pre-fields"]}>
              {Object.entries(response.result.ReturnDoc).map(([key, value]) => {
                if (key.startsWith("PDF")) {
                  return (
                    <div key={key}>
                      <p className="fw-bold mb-1">{key}:</p>
                      {value !== null ? (
                        <iframe
                          key={key}
                          src={value}
                          title={`iframe-${key}`}
                          width="100%"
                          height="400"
                        ></iframe>
                      ) : (
                        <span>Missing file</span>
                      )}
                    </div>
                  );
                } else if (key.startsWith("XML")) {
                  return (
                    <>
                      <p className="fw-bold mb-1">{key}:</p>
                      <a
                        key={key}
                        href={value}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {value}
                      </a>
                    </>
                  );
                }
                return null; // Skip rendering if the key doesn't match any condition
              })}
            </div>
          </Collapse>
        </>
      )}
    </div>
  );
};

export default Response;
